import { GraphQLFieldConfig, GraphQLNonNull, GraphQLString } from 'graphql'
import { Context } from '../shared'
import { routeType } from '../types/route'

export interface RouteQueryArgs {
  readonly id: string
}

export const route: GraphQLFieldConfig<any, Context, RouteQueryArgs> = {
  description: 'Get a route from the Apollo cache',
  type: new GraphQLNonNull(routeType),
  args: {
    id: {
      description: 'The ID of the route',
      type: new GraphQLNonNull(GraphQLString)
    }
  }
}
